export default __webpack_public_path__ + "static/media/portfolio_icon.b426376a.svg";